import React from "react";
import { DashboardEnvContext as DEC } from "./types";

const DashboardEnvContext = React.createContext<DEC | undefined>(undefined);
export default DashboardEnvContext;
